package ai.jessie.web

import ai.jessie.web.authentication.BrowserAuthenticationSessionPort
import ai.jessie.web.authentication.LocalAuthenticationSessionPort
import ai.jessie.web.customers.BrowserCustomerPort
import ai.jessie.web.customers.LocalCustomerPort
import ai.jessie.web.documents.BrowserDocumentPort
import ai.jessie.web.documents.BrowserDocumentWorkflowPort
import ai.jessie.web.documents.LocalDocumentPort
import ai.jessie.web.documents.LocalDocumentWorkflowPort
import ai.jessie.web.invoices.BrowserInvoiceArtefactPort
import ai.jessie.web.invoices.BrowserInvoicePort
import ai.jessie.web.invoices.BrowserInvoiceProgressPort
import ai.jessie.web.invoices.LocalInvoiceArtefactPort
import ai.jessie.web.invoices.LocalInvoicePort
import ai.jessie.web.invoices.LocalInvoiceProgressPort
import ai.jessie.web.members.BrowserMemberManagementPort
import ai.jessie.web.members.LocalMemberManagementPort
import ai.jessie.web.onboarding.BrowserOnboardingPort
import ai.jessie.web.onboarding.LocalOnboardingPort
import ai.jessie.web.onboarding.LocalOrganisationSelectionPort
import ai.jessie.web.profile.BrowserProfilePort
import ai.jessie.web.profile.LocalEmailChangePort
import ai.jessie.web.profile.LocalProfilePort
import ai.jessie.web.projects.BrowserProjectPort
import ai.jessie.web.projects.LocalProjectPort
import ai.jessie.web.settings.BrowserSettingsPort
import ai.jessie.web.settings.LocalSettingsPort
import ai.jessie.web.work.BrowserWorkPort
import ai.jessie.web.work.LocalWorkCalendarPort
import ai.jessie.web.work.LocalWorkPort
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.remember
import com.varabyte.kobweb.core.App
import com.varabyte.kobweb.silk.SilkApp

@App
@Composable
fun appEntry(content: @Composable () -> Unit) {
    val sessionPort = remember { BrowserAuthenticationSessionPort() }
    val onboardingPort = remember { BrowserOnboardingPort() }
    val memberPort = remember { BrowserMemberManagementPort() }
    val settingsPort = remember { BrowserSettingsPort() }
    val customerPort = remember { BrowserCustomerPort() }
    val profilePort = remember { BrowserProfilePort() }
    val projectPort = remember { BrowserProjectPort() }
    val workPort = remember { BrowserWorkPort() }
    val invoicePort = remember { BrowserInvoicePort() }
    val invoiceArtefactPort = remember { BrowserInvoiceArtefactPort() }
    val invoiceProgressPort = remember { BrowserInvoiceProgressPort() }
    val documentPort = remember { BrowserDocumentPort() }
    val documentWorkflowPort = remember { BrowserDocumentWorkflowPort() }
    CompositionLocalProvider(
        LocalAuthenticationSessionPort provides sessionPort,
        LocalOnboardingPort provides onboardingPort,
        LocalOrganisationSelectionPort provides onboardingPort,
        LocalMemberManagementPort provides memberPort,
        LocalSettingsPort provides settingsPort,
        LocalCustomerPort provides customerPort,
        LocalProfilePort provides profilePort,
        LocalEmailChangePort provides profilePort,
        LocalProjectPort provides projectPort,
        LocalWorkPort provides workPort,
        LocalWorkCalendarPort provides workPort,
        LocalInvoicePort provides invoicePort,
        LocalInvoiceArtefactPort provides invoiceArtefactPort,
        LocalInvoiceProgressPort provides invoiceProgressPort,
        LocalDocumentPort provides documentPort,
        LocalDocumentWorkflowPort provides documentWorkflowPort,
    ) {
        SilkApp { content() }
    }
}
